import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    NumberField,
    DateField,
    Filter,
    Edit,
    SimpleForm,
    ReferenceInput,
    SelectInput,
    ShowButton, Show,
    TabbedShowLayout, Tab, DateInput, DateTimeInput, FilterList, FilterListItem,
    useRecordContext, Pagination
} from 'react-admin';

import ShowActions from './showActions';

import { DeleteSweepOutlined } from "@mui/icons-material";
import { Card as MuiCard, CardContent } from "@mui/material";
import { withStyles } from '@mui/styles';
import ShowActionsAbholungenExport from "./showActionsAbholungenExport";

import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Box,
    Grid,
    Paper,
    Typography
} from '@mui/material';
import {
    History as HistoryIcon,
    HelpOutline as HelpOutlineIcon,
    ExpandMore as ExpandMoreIcon
} from '@mui/icons-material';
import { makeStyles } from '@mui/styles';

import {styled} from '@mui/material/styles';
import LinearProgress, {linearProgressClasses} from '@mui/material/LinearProgress';

import {AbfallartIcon, PaperCalendarDay} from "./index";
import { date2DateString, date2DateTimeString } from "./index";

const FilterAbfallart = () => (
    <FilterList
        label="Abfallart"
        icon={<DeleteSweepOutlined/>}
    >
        <FilterListItem
            label="Sperrmüll"
            value={{
                abfallart: 5
            }}
        />
        <FilterListItem
            label="Elektro"
            value={{
                abfallart: 6
            }}
        />
    </FilterList>
);

const Card = withStyles(theme => ({
    root: {
         [theme.breakpoints.up('sm')]: {
            order: -1, // display on the left rather than on the right of the list
            width: '15em',
            marginRight: '1em',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
}))(MuiCard);

const FilterSidebar = () => (
    <Card>
        <CardContent>
            <FilterAbfallart/>
        </CardContent>
    </Card>
);

const abholungFilterAbholgebietOptionRenderer = (props) => `${props.anmerkung} - ${props.name}`;

const AbholungFilter = (props) => {

    return (
        <Filter {...props}>
            <DateInput alwaysOn label="Abholdatum ab" source="abholdatum[after]"/>
            <ReferenceInput source="abholgebiet.landkreis" reference="landkreise"
                            sort={{field: 'name', order: 'ASC'}} perPage={99} alwaysOn allowEmpty>
                <SelectInput label="Landkreis" optionText={props.name} optionValue="id"/>
            </ReferenceInput>
            <ReferenceInput source="abholgebiet.id" reference="abholgebiete" filter={{landkreis: "/v2/landkreise/2"}}
                            sort={{field: 'name', order: 'ASC'}} perPage={99} alwaysOn allowEmpty>
                <SelectInput label="Abholgebiet" optionText={abholungFilterAbholgebietOptionRenderer} optionValue="id"/>
            </ReferenceInput>
        </Filter>
    )
};

const abholungenRowStyle = (record, index) => ({
    //https://material.io/design/color/the-color-system.html
    borderLeftColor: null != record.blocked ? '#B81F16' : 'white'
});

const AbholungListStatistics = (props) => {
    const record = useRecordContext({...props});
    var percent = 0;

    if(record) {
        if ( typeof(record.record) !== 'undefined' ) {
            if (record.record.menge_ist && record.record.menge_max)
                percent = record.record.menge_ist * 100 / record.record.menge_max;
        } else {
            if (record.menge_ist && record.menge_max)
                percent = record.menge_ist * 100 / record.menge_max;
        }
    }

    return (
        <Box sx={{display: 'flex', alignItems: 'center'}}>
            <Box sx={{width: '100%', mr: 1}}>
                <BorderLinearProgress variant="determinate" value={percent}/>
            </Box>
            <Box sx={{minWidth: 35}}>
                <Typography variant={"caption"}>
                    {`${Math.round(percent,)}%`}
                </Typography>
            </Box>
        </Box>
    );
};

const AbholungList = (props) => {
    return (
        <List title={"Abholungen"}
              filters={<AbholungFilter/>}
              aside={<FilterSidebar/>}
              filterDefaultValues={{"abholgebiet.landkreis": "2", abholdatum: {after: (new Date()).toISOString()}}}
              sort={{field: 'abholdatum', order: 'ASC'}}
              pagination={<Pagination rowsPerPageOptions={[10, 15, 20]} {...props} />}
              exporter={false}
              {...props}>
            <Datagrid rowClick="edit"
                  sx={{
                      '& .RaDatagrid-headerCell': {
                          fontWeight: 'bold',
                      },
                      '& .RaDatagrid-row': {
                          borderLeftWidth: '5px',
                          borderLeftStyle: 'solid',
                          borderLeftColor: '#fff'
                      },
                  }}
                rowStyle={abholungenRowStyle}>
                <DateField source={"abholdatum"}
                           options={{weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}}/>
                <TextField source={"abholgebiet.beschreibung"} label={"Abholgebiet"}/>
                <TextField source={"abfallart.name"} label={"Abfallart"}/>
                <NumberField source={"menge_ist"} label={"Ist"}/>
                <NumberField source={"menge_max"} label={"Max"}/>
                <AbholungListStatistics label={"Auslastung"}/>
                <DateField source={"blocked"} label={"Geschlossen"} options={{
                    year: '2-digit',
                    month: '2-digit',
                    day: '2-digit',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                }}/>
                <ShowButton label={"Details"}/>
            </Datagrid>
        </List>
    );
};

const AbholungShowTitle = (props) => {
    return <span> Abholung | {props.abfallart.name} {date2DateString(props.abholdatum)}, {props.abholgebiet.name}</span>;
};

const Aside = (props) => {
    const record = useRecordContext(props);
    if(!record)
        return(<div/>);

    var closed = date2DateTimeString(record.blocked);

    return (
        <div style={{width: 340, marginLeft: '1em', }}>
            <Paper elevation={2}
                   sx={{width: 300, backgroundColor: '#ffffff', padding: '20px'}}>
                <Grid container spacing={3}>
                    <Grid item xs={2}>
                        <HistoryIcon color="info" fontSize="large"/>
                    </Grid>
                    <Grid item xs={10}>
                        <Typography variant="h6">Historie</Typography>
                        <br/>
                        <Typography variant="body2">
                            <b>geschlossen</b><br/>
                            {closed}
                            <br/>
                            <br/>
                            <b>durch</b><br/>
                            {record.blocked_by}
                        </Typography>
                    </Grid>
                </Grid>
            </Paper>
            <div style={{width: 340, marginTop: '1em', padding: 0}}>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <HelpOutlineIcon color="info" sx={{marginRight: '10px'}}/>
                        <Typography>Hilfe</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body2">
                            <b>EXPORT</b><br/>
                            Der Export kann beliebig oft vorgenommen werden (zu Testzwecken, für Vorabprüfungen, etc.).
                            Erst mit dem Setzen eines geschlossen-Datums sind keine Anmeldungen für den Abholtermin mehr
                            möglich.<br/>
                            <br/>
                            Vorbereitungen:<br/>
                            <ul>
                                <li>Über die <a href={"#/anmeldungen"}>Anmeldungen</a> eventuelle Doppeleinträge
                                    identifizieren und stornieren
                                </li>
                                <li>Abholtermin schließen (Datum/Uhrzeit auswählen und speichern). Ab diesem Zeitpunkt
                                    können keine Anmeldungen mehr für diesen Termin über das Sperrmüllportal vorgenommen
                                    werden.
                                </li>
                            </ul>
                            Export:<br/>
                            <ul>
                                <li>Über [EXPORT ANMELDUNGEN] werden die Anmeldungen als .csv-Datei im
                                    Standard-Download-Ordner gespeichert
                                </li>
                                <li>Über den Windows-Editor (rechte Maustaste im Windows Datei-Explorer / Öffnen mit /
                                    Editor) kann die Datei nochmals auf eventuelle Unregelmäßigkeiten geprüft werden
                                </li>
                                <li>Manueller Versand per E-Mail für die Tourenplanung</li>
                            </ul>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </div>
        </div>
    );
};

const AbholungShowVisual = (props) => {
    const record = useRecordContext({...props});
    var percent = record.menge_ist ? record.menge_ist * 100 / record.menge_max : 0;
    var mengeIstColor = '#3DA60F';
    if (percent > 60) {
        mengeIstColor = '#ffeb3b'
    }
    if (percent > 85) {
        mengeIstColor = '#f44336'
    }

    return (
        <Box>
            <Box component="div" mt={2} sx={{width: '50%', float: 'right', textAlign: 'center'}}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Paper elevation={3} sx={{
                            p: 2,
                            background: '#B83BA1',
                            color: '#fff',
                            textAlign: 'left',
                            marginBottom: '20px'
                        }}>
                            <Typography variant={"h4"}>
                                {record.anzahl_ist ? record.anzahl_ist : 0}
                            </Typography>
                            <Typography variant={"caption"}>
                                Anmeldungen
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={3}>
                        <Paper elevation={3} sx={{
                            p: 2,
                            background: '#2872b7',
                            color: '#fff',
                            textAlign: 'center'
                        }}>
                            <AbfallartIcon {...props}/>
                        </Paper>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Paper elevation={3} sx={{
                            p: 2,
                            background: '#41B81F',
                            color: '#fff',
                            textAlign: 'left'
                        }}>
                            <Typography variant={"h4"}>
                                {record.menge_ist ? record.menge_ist : 0}
                            </Typography>
                            <Typography variant={"caption"}>
                                Anmeldungen in m³
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={6}>
                        <Paper elevation={3} sx={{
                            p: 2,
                            background: '#2872b7',
                            color: '#fff',
                            textAlign: 'left'
                        }}>
                            <Typography variant={"h4"}>
                                {record.menge_max}
                            </Typography>
                            <Typography variant={"caption"}>
                                Menge max in m³
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                    <Box sx={{width: '100%', mr: 1}}>
                        <BorderLinearProgress variant="determinate" value={percent}
                                              sx={{marginTop: '30px', marginBottom: '30px'}}/>
                    </Box>
                    <Box sx={{minWidth: 35}}>
                        <Typography variant={"caption"}>
                            {`${Math.round(percent,)}%`}
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <Box component="div" mt={2} mr={2} sx={{width: '25%', float: 'right'}}>
                <PaperCalendarDay {...props}/>
            </Box>
        </Box>
    );
};

const AbholungShow = (props) => {

    return (
        <Show title={<AbholungShowTitle/>} actions={<ShowActions/>} aside={<Aside/>}  {...props}>
            <TabbedShowLayout>
                <Tab label="Abholung">
                    <AbholungShowVisual/>
                    <TextField source={"abholgebiet.name"} label={"Abholgebiet"}/>
                    <TextField source={"abholgebiet.beschreibung"} label={"Abholgebiet Beschreibung"}/>
                </Tab>
                <Tab label="Export">
                    <AbholungFastEdit actions={<ShowActionsAbholungenExport/>} {...props} />
                </Tab>
            </TabbedShowLayout>
        </Show>
    );
};

const showStyles = makeStyles({
    tabbedLayout: {
        marginBottom: '1em'
    }
});

const AbholungFastEdit = (props) => {
    const showClasses = showStyles();

    return (
        <Edit title={" / Export"} className={showClasses.tabbedLayout}  {...props}>
            <SimpleForm>
                <DateTimeInput variant="outlined" source={"blocked"} label={"geschlossen"}/>
            </SimpleForm>
        </Edit>
    );
};

const BorderLinearProgress = styled(LinearProgress)(({theme}) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === 'light' ? '#2872b7' : '#308fe8',
    },
}));

export {AbholungList, AbholungListStatistics, AbholungShow};
